import clsx from 'clsx';
import React from 'react';

import { TextButton } from '@components/Button/variants';
import IconClose from '@components/Images/Rebranding/IconClose';
import { upgrade_subscription_path } from '@routes';

/** Cookie set when the user dismisses the Listen onboarding; 6-month TTL set by the parent. */
export const AUDIO_LISTEN_ONBOARDING_COOKIE = 'audio-listen-onboarding-dismissed';

type AudioListenOnboardingTooltipProps = {
  isMonthlySubscriber: boolean;
  setShowListenOnboarding: (show: boolean) => void;
};

const AudioListenOnboardingTooltip = ({
  isMonthlySubscriber,
  setShowListenOnboarding,
}: AudioListenOnboardingTooltipProps) => {
  const toolTipText = isMonthlySubscriber
    ? 'Audio articles are available to Annual and Pro subscribers.'
    : 'Play the audio version of this article to listen on the go.';
  const toolTipButtonText = isMonthlySubscriber ? 'Upgrade today' : 'Got it';

  const handleToolTipButtonClick = () => {
    if (isMonthlySubscriber) {
      window.location.href = upgrade_subscription_path();
    } else {
      setShowListenOnboarding(false);
    }
  };
  return (
    <div
      role="dialog"
      aria-labelledby="audio-listen-onboarding-title"
      aria-modal="false"
      className={clsx(
        'shadow-lg pointer-events-auto absolute bottom-full left-1/2 z-20 mb-12 w-[min(100vw-48px,400px)] -translate-x-1/2 rounded-4 bg-grayscale-charcoal px-20 pb-16 pt-20 text-white print:hidden',
        "after:absolute after:-bottom-8 after:left-1/2 after:h-16 after:w-16 after:-translate-x-1/2 after:rotate-45 after:rounded-br-4 after:bg-grayscale-charcoal after:content-['']"
      )}
    >
      <button
        type="button"
        className="absolute right-8 top-8 flex h-32 w-32 touch-manipulation items-center justify-center border-none bg-transparent text-white"
        onClick={() => setShowListenOnboarding(false)}
        aria-label="Close audio tip"
      >
        <IconClose className="stroke-2" height={12} width={12} />
      </button>
      <p
        id="audio-listen-onboarding-title"
        className="m-0 pr-28 font-suisse-intl text-body-md font-normal leading-snug text-white"
      >
        {toolTipText}
      </p>
      <div className="mt-8">
        <TextButton
          as={isMonthlySubscriber ? 'link' : 'button'}
          type="button"
          className="inline !w-fit p-0 font-suisse-intl text-button-md text-primary-pink underline"
          onClick={handleToolTipButtonClick}
        >
          {toolTipButtonText}
        </TextButton>
      </div>
    </div>
  );
};

export default AudioListenOnboardingTooltip;
